<template>
  <ValidationObserver
    v-slot="{ handleSubmit }"
    tag="div"
    class="request-response"
  >
    <project-request
      v-model="response"
      :form="form"
      v-if="!done"
    ></project-request>
    <div v-if="!done" class="field is-grouped is-grouped-centered">
      <button
        class="button is-primary is-wide"
        @click="handleSubmit(submitResponse)"
      >
        Submit
      </button>
    </div>
    <div v-if="done">
      <div class="page-title has-text-centered form-done">
        Form submitted. Thank you!
      </div>
    </div>
  </ValidationObserver>
</template>

<script>
import ProjectRequest from '@/components/projectRequests/ProjectRequest';

export default {
  name: 'ProjectRequestResponse',
  components: { ProjectRequest },
  props: {
    guid: {}
  },
  data() {
    return {
      form: {},
      response: {},
      done: false
    };
  },
  mounted() {
    this.axiosRequest('get', `Forms/${this.guid}`)
      .then(response => {
        this.form = response.data;
        const questions = _.sortBy(this.form.formQuestions, 'sortOrder');
        questions.map(item => {
          this.$set(
            item,
            'formQuestionChoices',
            _.sortBy(item.formQuestionChoices, 'sortOrder')
          );
        });
        this.$set(this.form, 'formQuestions', questions);
      })
      .catch(error => {
        this.showErrorMessage(error);
      });
  },
  methods: {
    submitResponse() {
      const data = {
        userID: this.$store.state.user.userID,
        responses: this.response.responses.map(r => ({
          ...r,
          responseChoices: r.responseChoices.map(c => ({
            formQuestionChoiceID: c
          }))
        }))
      };
      console.log(JSON.stringify(data, null, 2));

      this.axiosRequest('post', `Forms/${this.form.formID}/Responses`, data)
        .then(response => {
          this.showSuccessMessage('Form submitted with success');
          this.done = true;
        })
        .catch(error => {
          this.showErrorMessage(error);
        });
    }
  }
};
</script>

<style lang="scss">
.request-response {
  padding-bottom: $block-spacing * 14;
  .field.is-grouped {
    margin-top: $block-spacing * 2;
  }
}

.form-done {
  padding: 100px 20px;
}
</style>
